import { render, staticRenderFns } from "./LeftSideMenu.vue?vue&type=template&id=194e0544&scoped=true&"
import script from "./LeftSideMenu.vue?vue&type=script&lang=js&"
export * from "./LeftSideMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194e0544",
  null
  
)

export default component.exports